// frontend/src/data/culturalData.js
import nghiLeData from "./nghiLeData";
import giupVuiData from "./giupVuiData";
import tuGiaData from "./tuGiaData";
import sangTacMoiData from "./sangTacMoiData";
import hatSacBuaData from "./hatSacBuaData";
import truyenThuaData from "./truyenThuaData";

const culturalData = [
  ...nghiLeData,
  ...giupVuiData,
  ...tuGiaData,
  ...sangTacMoiData,
  ...hatSacBuaData,
  ...truyenThuaData,
];

export default culturalData;
